import React, {useState} from 'react';

import {t} from '../../../services/localization/localizationService';
import {setQuizAnswer} from '../../../state/slice/loyalty';
import {dispatch} from '../../../state/store';
import ClubPageEmotions from '../components/ClubPageEmotions';

const ClubPageReportQuizFirstSlide = (props) => {
    const {quizType, questionId, titleStrCode} = props;
    const [activeType, setActiveType] = useState(undefined);

    const onEmotionClick = (type) => {
        setActiveType(type);
        dispatch(setQuizAnswer({quizType, questionId, optionId: type}));
    };

    return (
        <div className='flex h-full flex-col gap-4'>
            <div className='text-32 font-bold leading-[120%]'>{t(titleStrCode)}</div>
            <ClubPageEmotions
                titleStrCode={titleStrCode}
                className='my-auto h-full'
                activeType={activeType}
                setActiveType={onEmotionClick}
            />
        </div>
    );
};

export default ClubPageReportQuizFirstSlide;
